import {CustomerInfo} from "./customer-info";
import {CustomerLogin} from "./customer-login";
import {OnboardingBsa, OnboardingDocumentUpload, OnboardingEmployment, OnboardingTellUsAboutYourself} from "./models";
import {OnboardingApplicant} from "./onboarding-applicant.model";

export class OnboardingRequest {
  copyAddressFromPrimary?: boolean;
  applicants: OnboardingApplicant[] = new Array();
  bsaInfo: OnboardingBsa = new OnboardingBsa();
  customerLogin: CustomerLogin = new CustomerLogin();
}
